/**
 * Home Page Configuration Selector
 *
 * Loads client-specific configuration based on user's client property
 */

import defaultHomeConfig from './default';
import grmHomeConfig from './grm';
import demHomeConfig from './dem';

const configs = {
  grm: grmHomeConfig,
  dem: demHomeConfig,
  default: defaultHomeConfig
};

/**
 * Get home page configuration for a specific client
 *
 * @param {string} client - Client identifier (grm, dem, etc.)
 * @returns {Object} Home page configuration object
 */
export const getHomeConfig = (client = 'default') => {
  const clientLower = client?.toLowerCase() || 'default';
  const clientConfig = configs[clientLower] || {};

  // Merge default config with client-specific config
  return {
    ...defaultHomeConfig,
    ...clientConfig
  };
};

export default getHomeConfig;
